import React, { useState } from 'react';

import { PlusOutlined, TeamOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

import useCan from '@shared/permissions/useCan';
import ListPageHeader from '@shared/ListPageHeader';
import CreateUserInvitationModal from '@shared/user_invitations/CreateUserInvitationModal';
import UserInvitationsList from '@shared/user_invitations/UserInvitationsList';

import { permissionTemplateService } from '@services/admin/permissionTemplateService';
import { userInvitationService } from '@services/admin/userInvitationService';

import AdminUsersTable from './UsersTable';

const TAB_KEYS = {
  USERS: 'users',
  INVITATIONS: 'invitations',
};

export default function AdminUsersList() {
  const { t } = useTranslation();
  const can = useCan();
  const [activeTab, setActiveTab] = useState(TAB_KEYS.USERS);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [invitationsRefreshKey, setInvitationsRefreshKey] = useState(0);

  const canCreate = can('users:write');

  const items = [
    {
      key: TAB_KEYS.USERS,
      label: (
        <span>
          <TeamOutlined />
          {' '}{t('admin.users.tabs.users')}
        </span>
      ),
      children: <AdminUsersTable />,
    },
    {
      key: TAB_KEYS.INVITATIONS,
      label: (
        <span>
          <MailOutlined />
          {' '}{t('admin.users.tabs.invitations')}
        </span>
      ),
      children: (
        <UserInvitationsList
          userInvitationService={userInvitationService}
          templateService={permissionTemplateService}
          role="admin"
          showCard={false}
          refreshKey={invitationsRefreshKey}
        />
      ),
    },
  ];

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['settings', 'settings.users']}
        actions={
          canCreate && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setIsCreateModalVisible(true)}
            >
              {t('common.button.new')}
            </Button>
          )
        }
      />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
      />
      <CreateUserInvitationModal
        open={isCreateModalVisible}
        onClose={() => setIsCreateModalVisible(false)}
        onSuccess={() => {
          setActiveTab(TAB_KEYS.INVITATIONS);
          setInvitationsRefreshKey((k) => k + 1);
        }}
        userInvitationService={userInvitationService}
      />
    </div>
  );
}
